import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {Modal, notification, Spin} from 'antd';
import {FormattedMessage} from "react-intl";
import {cw, hp} from '../../utils';
import company from '../../assets/img/company.png';
import '../../assets/css/Header.scss';
import {accountLogin} from "../../store/auth/_authActions";

const ChooseAccount = (props) => {
    const { _utils: { lang } } = props;
    const [user, setUser] = useState(undefined);
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        if (hp.getCookie("user_token") && hp.getCookie('user')) {
            axios({
                method: "GET",
                url: `${hp.getApiBaseUrl()}/users/${hp.getCookie('user_id').trim()}/accounts`,
                headers: { "x-access-token": hp.getCookie("user_token") },
            }).then((response) => {
                const res = response.data;
                if (res.statusCode === 200) {
                    if (res.data.length > 0) {
                        setAccounts(res.data);
                        setUser(JSON.parse(hp.getCookie('user')));
                    } else {
                        window.location.assign(`/${lang || 'en'}/create-account`);
                    }
                }
            });
        } else {
            window.location.assign(`/${lang || 'en'}/signin`);
        }
    }, [lang]);

    return (
        <React.Fragment>
            <Modal centered={true} closable={false} maskClosable={false} open={true} width={400} className="esoko__acc__switcher" footer={null}
                title={
                    <div>
                        <b><FormattedMessage id="Header" defaultMessage="Choose an organization to switch into" /></b>
                    </div>
                }
            >
                {accounts.length > 0 ? (
                    accounts.map(account => (
                        <SwitcherAccountCard key={account.id} account={account} activeAccount={{}} user={user} clickable={true} />
                    ))
                ) : (
                    <div style={{ width: '100%', paddingTop: '17px', textAlign: 'center' }}>
                        <Spin size="small" spinning={true} />
                    </div>
                )}
            </Modal>
        </React.Fragment>
    );
};

export default ChooseAccount;


const SwitcherAccountCard = props => {
    const { account, active, activeAccount, user } = props;
    const [spinning, setSpinning] = useState(false);

    const onClick = () => {
        if (props.clickable) {
            setSpinning(true);
            accountLogin(account.id , user.user_id).then((res) => {
                const {accountToken , userRole} = res;
                hp.setCookie("user_token", accountToken);
                hp.setCookie("project_id", account.id);
                hp.setCookie("active_account", JSON.stringify(account));
                hp.setCookie(
                    "user",
                    JSON.stringify({
                        ...user,
                        role: userRole,
                    })
                );
               window.location.assign(hp.getSuccessRedirect());
            }).catch(() => {
                notification.error({ message: props.intl.formatMessage(cw['SwitchAccount.Failed']) });
            });
        }
    }

    return (
        (account.name && (active || account.id !== activeAccount.id)) && (
            <Spin size="small" spinning={spinning}>
                <div className={`caard ${!active ? 'active' : ''}`} onClick={onClick}>
                    <div className="logo">
                        <img src={account.logo || company} alt={account.name} />
                    </div>
                    <div className="text">
                        <div>
                            <div className="title">{account.name}</div>
                            <div className="admin">{account.industry}</div>
                        </div>
                    </div>
                    <div className="clear"></div>
                </div>
            </Spin>
        )
    )
}
